<template>
  <a class="card card-status-top text-uppercase" :href="link" :class="`${colorIndicator}-indicator`">
    <template v-if="loading">
      <Skeleton col="2" />
      <Skeleton col="4" animation-duration="1.8s" />
      <Skeleton col="1" animation-duration="2s" />
    </template>

    <template v-else>
      <p><strong>{{ data.title }}</strong></p>
      <h3><strong>{{ data.count || 0 }}</strong></h3>
      <h4 v-if="dataSum">{{ data.sum || 0 | price }}</h4>
    </template>
  </a>
</template>

<script>
import Skeleton from '@/components/utils/Skeleton.vue'

export default {
  name: 'Card',
  components: { Skeleton },
  computed: {
    colorIndicator() {
      return this.data.color || 'gray'
    }
  },
  props: {
    data: { required: true, type: Object },
    loading: { required: true, type: Boolean },
    dataSum: { required: true, type: Boolean },
    link: { required: false, type: String }
  }
}
</script>

<style scoped>
  .card {
    text-decoration: none;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }

  [data-theme="dark"] .card:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.5);
  }
</style>
